


















































import { Component, Prop, Vue } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { CountryOptions, NationalityOptions } from '@master/model/options/NationalityAndCountryOptions'
import { ClientPolicyDto, PersonalInfo, PolicyIndividualDTO } from '../../api'
import { PolicyClientMeta } from '../../model/PolicyClientMeta'
import { options } from '@core/model/UIOptions'
import { IDateService } from '@master/services/IDateService'

@Component({
  components: {
    AppForm
  }
})
export default class PolicyIndividualDetailSection extends Vue {
  @Prop({ default: {} }) policyIndividual: PolicyIndividualDTO
  @Prop({ default: [] }) private rolesOption: options[]
  @Prop({ default: [] }) private relationshipOptions: options[]
  @Prop({ default: [] }) private identityTypeOptions: options[]
  @Prop({ default: [] }) private citizenshipOptions: options[]
  @Prop({ default: [] }) private maritalStatusOptions: options[]
  @Prop({ default: [] }) private eduLevelOptions: options[]
  @Prop({ default: [] }) private spokenLangOptions: options[]
  @Prop({ default: [] }) private writtenLangOptions: options[]
  @Prop({ default: [] }) private incomeTierOptions: options[]
  @Prop({ default: {} }) private policy: ClientPolicyDto
  @Prop() private dateService: IDateService
  @Prop({ default: false }) isAllActionDisabled

  get clientDataSnapshot () {
    return this.policyIndividual?.clientDataSnapshot
  }

  get personalInfoJson () {
    return this.clientDataSnapshot?.personalInfoJson
  }

  get isAccountTypeIndividual () {
    return this.clientDataSnapshot?.accountType === 'individual'
  }

  get isAccountTypeCorporate () {
    return this.clientDataSnapshot?.accountType === 'corporate'
  }

  get isNotOpsStaff () {
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  get isDisabled () {
    return this.isNotOpsStaff || this.isLiveData
  }

  get isMainOwner () {
    return this.policyIndividual.isMainOwner
  }

  get isLiveData () {
    return this.policyIndividual?.isLiveData
  }

  get lastSyncSince () {
    const lastSync = this.policyIndividual?.clientDataSnapshot.lastSyncSince
    if (lastSync) {
      return `Synced on: ${this.dateService.format(lastSync, 'DD/MM/YYYY HH:MM:ss')}`
    }
    return ''
  }

  get importantStructure (): FormStructure<any> {
    return [
      {
        label: 'Account Type',
        key: 'accountType',
        disabled: true
      },
      {
        label: this.isAccountTypeCorporate ? 'Entity Exists Since' : 'Individual Exists Since',
        key: 'ctm',
        type: 'date',
        disabled: true
      },
      {
        label: 'Name',
        key: 'name',
        disabled: this.isDisabled
      },
      {
        label: 'Identity Type',
        model: {
          get: () => this.personalInfoJson?.identityType,
          set: (val) => {
            this.personalInfoJson.identityType = val
          }
        },
        options: this.identityTypeOptions,
        disabled: this.isDisabled
      },
      {
        label: this.isAccountTypeIndividual ? 'NRIC/FIN/Passport No.' : (this.isAccountTypeCorporate ? 'UEN' : 'NRIC/FIN/Passport No.'),
        key: 'nric',
        disabled: this.isDisabled
      }
    ]
  }

  get policyRelatedStructure (): FormStructure<PolicyIndividualDTO> {
    return [
      {
        label: 'Roles',
        key: 'role',
        type: 'multi',
        options: this.rolesOption,
        disabled: this.isNotOpsStaff
      },
      {
        label: 'Main Owner',
        key: 'isMainOwner',
        type: 'single-checkbox',
        disabled: true
      },
      {
        label: 'Relationship to Main Owner',
        key: 'relationship',
        options: this.relationshipOptions,
        show: this.isAccountTypeIndividual && !this.policyIndividual.isMainOwner && !['employeebenefits', 'group-eb', 'group-eb-tailored'].includes(this.policy.type),
        disabled: this.isNotOpsStaff
      }
    ]
  }

  get corporateClientStructures (): FormStructure<PolicyClientMeta> {
    return [
      {
        label: 'Date of Registration',
        key: 'registrationDate',
        type: 'date',
        disabled: this.isDisabled
      }
    ]
  }

  get individualClientStructures (): FormStructure<PolicyClientMeta> {
    return [
      {
        label: 'Salutation',
        key: 'title',
        options: [
          { label: 'Dr', value: 'dr' },
          { label: 'Mr', value: 'mr' },
          { label: 'Mrs', value: 'mrs' },
          { label: 'Mdm', value: 'mdm' },
          { label: 'Miss', value: 'miss' }
        ],
        disabled: this.isDisabled
      },
      {
        label: 'Citizenship',
        model: {
          get: () => this.personalInfoJson?.citizenship,
          set: (val) => {
            this.personalInfoJson.citizenship = val
          }
        },
        options: this.citizenshipOptions,
        disabled: this.isDisabled
      },
      {
        label: 'Please specify Nationality (1)',
        model: {
          get: () => this.personalInfoJson?.nationalityOthers,
          set: (val) => {
            this.personalInfoJson.nationalityOthers = val
          }
        },
        options: this.nationalityOptions,
        show: this.personalInfoJson?.citizenship !== 'singaporean',
        disabled: this.isDisabled
      },
      {
        label: 'Gender',
        model: {
          get: () => this.personalInfoJson?.gender,
          set: (val) => {
            this.personalInfoJson.gender = val
          }
        },
        options: [
          { label: 'Male', value: 'male' },
          { label: 'Female', value: 'female' }
        ],
        disabled: this.isDisabled
      },
      {
        label: 'Marital Status',
        model: {
          get: () => this.personalInfoJson?.maritalStatus,
          set: (val) => {
            this.personalInfoJson.maritalStatus = val
          }
        },
        options: this.maritalStatusOptions,
        disabled: this.isDisabled
      },
      {
        label: 'Date of Birth',
        model: {
          get: () => this.personalInfoJson?.dob,
          set: (val) => {
            this.personalInfoJson.dob = val
          }
        },
        type: 'date',
        disabled: this.isDisabled
      },
      {
        label: 'Exact Duties/Function',
        model: {
          get: () => this.personalInfoJson?.exactDuties,
          set: (val) => {
            this.personalInfoJson.exactDuties = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Occupation',
        model: {
          get: () => this.personalInfoJson?.occupation,
          set: (val) => {
            this.personalInfoJson.occupation = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Company Name',
        model: {
          get: () => this.personalInfoJson?.companyName,
          set: (val) => {
            this.personalInfoJson.companyName = val
          }
        },
        classes: ['colspan'],
        disabled: this.isDisabled
      }
    ]
  }

  get addressOne (): FormStructure<PolicyClientMeta> {
    return [
      {
        label: 'Address',
        model: {
          get: () => this.personalInfoJson?.residentialAddressOne,
          set: (val) => {
            this.personalInfoJson.residentialAddressOne = val
            this.updateLastUpdateDate()
          }
        },
        classes: ['colspan'],
        disabled: this.isDisabled
      },
      {
        label: 'Postal Code',
        model: {
          get: () => this.personalInfoJson?.postalCodeOne,
          set: (val) => {
            this.personalInfoJson.postalCodeOne = val
            this.updateLastUpdateDate()
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Country',
        model: {
          get: () => this.personalInfoJson?.countryOfResidenceOne,
          set: (val) => {
            this.personalInfoJson.countryOfResidenceOne = val
            this.updateLastUpdateDate()
          }
        },
        options: this.countryOptions,
        disabled: this.isDisabled
      },
      {
        label: 'Last Updated Date',
        model: {
          get: () => this.personalInfoJson?.lastUpdatedDate,
          set: (val) => {
            this.personalInfoJson.lastUpdatedDate = val
          }
        },
        type: 'date'
      }
    ]
  }

  get addressTwo (): FormStructure<PolicyClientMeta> {
    return [
      {
        label: 'Residential Address 2',
        model: {
          get: () => this.personalInfoJson?.residentialAddressTwo,
          set: (val) => {
            this.personalInfoJson.residentialAddressTwo = val
            this.updateLastUpdateDate()
          }
        },
        classes: ['colspan'],
        disabled: this.isNotOpsStaff
      },
      {
        label: 'Postal Code 2',
        model: {
          get: () => this.personalInfoJson?.postalCodeTwo,
          set: (val) => {
            this.personalInfoJson.postalCodeTwo = val
            this.updateLastUpdateDate()
          }
        },
        disabled: this.isNotOpsStaff
      },
      {
        label: 'Country 2',
        model: {
          get: () => this.personalInfoJson?.countryOfResidenceTwo,
          set: (val) => {
            this.personalInfoJson.countryOfResidenceTwo = val
            this.updateLastUpdateDate()
          }
        },
        options: this.countryOptions,
        disabled: this.isNotOpsStaff
      },
      {
        label: 'Last Updated Date',
        model: {
          get: () => this.personalInfoJson?.lastUpdatedDate,
          set: (val) => {
            this.personalInfoJson.lastUpdatedDate = val
          }
        },
        type: 'date'
      }
    ]
  }

  get mailingAddress (): FormStructure<PolicyClientMeta> {
    return [
      {
        label: 'Mailing Address',
        model: {
          get: () => this.personalInfoJson?.mailingAddress,
          set: (val) => {
            this.personalInfoJson.mailingAddress = val
          }
        },
        classes: ['colspan'],
        disabled: this.isNotOpsStaff,
        options: this.mailingAddressOptions
      }
    ]
  }

  get mailingAddressOptions () {
    if (this.isAccountTypeCorporate) {
      return [
        { label: 'Registered Address', value: 'Registered Address' },
        { label: 'Other Address', value: 'Other Address' }
      ]
    }
    return [
      { label: 'Residential Address', value: 'Residential Address' },
      { label: 'Other Address', value: 'Other Address' }
    ]
  }

  get contactInfo (): FormStructure<PolicyClientMeta> {
    return [
      {
        label: 'Mobile No 1',
        model: {
          get: () => this.personalInfoJson?.mobileNoOne,
          set: (val) => {
            this.personalInfoJson.mobileNoOne = val
          }
        },
        show: !this.isAccountTypeCorporate,
        disabled: this.isDisabled
      },
      {
        label: 'Office No 1',
        model: {
          get: () => this.personalInfoJson?.officeNoOne,
          set: (val) => {
            this.personalInfoJson.officeNoOne = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Home No 1',
        model: {
          get: () => this.personalInfoJson?.homeNoOne,
          set: (val) => {
            this.personalInfoJson.homeNoOne = val
          }
        },
        show: !this.isAccountTypeCorporate,
        disabled: this.isDisabled
      },
      {
        label: 'Email 1',
        model: {
          get: () => this.personalInfoJson?.emailOne,
          set: (val) => {
            this.personalInfoJson.emailOne = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Mobile No 2',
        model: {
          get: () => this.personalInfoJson?.mobileNoTwo,
          set: (val) => {
            this.personalInfoJson.mobileNoTwo = val
          }
        },
        show: !this.isAccountTypeCorporate,
        disabled: this.isDisabled
      },
      {
        label: 'Office No 2',
        model: {
          get: () => this.personalInfoJson?.officeNoTwo,
          set: (val) => {
            this.personalInfoJson.officeNoTwo = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Home No 2',
        model: {
          get: () => this.personalInfoJson?.homeNoTwo,
          set: (val) => {
            this.personalInfoJson.homeNoTwo = val
          }
        },
        show: !this.isAccountTypeCorporate,
        disabled: this.isDisabled
      },
      {
        label: 'Email No 2',
        model: {
          get: () => this.personalInfoJson?.emailTwo,
          set: (val) => {
            this.personalInfoJson.emailTwo = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Fax 1',
        model: {
          get: () => this.personalInfoJson?.faxOne,
          set: (val) => {
            this.personalInfoJson.faxOne = val
          }
        },
        show: this.isAccountTypeCorporate,
        disabled: this.isDisabled
      },
      {
        label: 'Fax 2',
        model: {
          get: () => this.personalInfoJson?.faxTwo,
          set: (val) => {
            this.personalInfoJson.faxTwo = val
          }
        },
        show: this.isAccountTypeCorporate,
        disabled: this.isDisabled
      }
    ]
  }

  get clientStructures (): FormStructure<PolicyClientMeta> {
    if (this.isAccountTypeCorporate) {
      return this.corporateClientStructures
    } else {
      return this.individualClientStructures
    }
  }

  get incomeEducationLanguageStructures (): FormStructure<PersonalInfo> {
    return [
      {
        show: this.isAccountTypeIndividual,
        label: 'Annual Income Range',
        key: 'annualIncomeRange',
        options: this.incomeTierOptions,
        disabled: this.isDisabled
      },
      {
        show: this.isAccountTypeIndividual,
        label: 'Highest Education Level',
        key: 'highestEducationLevel',
        options: this.eduLevelOptions,
        disabled: this.isDisabled
      },
      {
        show: this.isAccountTypeIndividual,
        label: 'Spoken Language(s)',
        key: 'spokenLanguage',
        type: 'checkbox',
        classes: ['colspan'],
        options: this.spokenLangOptions.filter(opt => opt.value !== ''),
        disabled: this.isDisabled
      },
      {
        label: 'Specify Spoken Language',
        key: 'spokenLanguageOthers',
        classes: ['colspan'],
        show: this.isAccountTypeIndividual && this.personalInfoJson?.spokenLanguage.includes('others'),
        disabled: this.isDisabled
      },
      {
        show: this.isAccountTypeIndividual,
        label: 'Written Language(s)',
        key: 'writtenLanguage',
        type: 'checkbox',
        classes: ['colspan'],
        options: this.writtenLangOptions.filter(opt => opt.value !== ''),
        disabled: this.isDisabled
      },
      {
        label: 'Specify Written Language',
        key: 'writtenLanguageOthers',
        classes: ['colspan'],
        show: this.isAccountTypeIndividual && this.personalInfoJson?.writtenLanguage.includes('others'),
        disabled: this.isDisabled
      }
    ]
  }

  get nationalityOptions () {
    return NationalityOptions
  }

  get countryOptions () {
    return CountryOptions
  }

  updateLastUpdateDate () {
    setTimeout(() => {
      const date = (new Date()).getTime()
      this.personalInfoJson.lastUpdatedDate = date
    }, 1500)
  }
}
